import { INITIAL_STATE } from "../constants/AppConstants";

export default (state = {}, action = {}) => {
  switch (action.type) {
    case "RESET_STORE_FOR_TESTS":
      let newState = {
        ...INITIAL_STATE,
        auth: state.auth
      };

      return newState;
    default:
      return state;
  }
};
